<template>
  <app-collapse class="mt-1">
    <app-collapse-item
      :is-visible="false"
      class="collapsible-section-bg"
      title="Packaging"
    >
      <template #header>
        <span
          class="lead collapse-title"
        >
          <section-status-icon
            :has-data="hasPackagingData"
            :has-errors="item.issues && item.issues.length > 0"
          />
          Packaging
        </span>
      </template>
      <div
        v-for="(pkg, pkgIndex) in item.packaging"
        :key="pkgIndex"
        class="border rounded pl-3 pr-3 pt-1 mb-2"
      >
        <b-row>
          <b-col
            cols="12"
            md="4"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Type of packages"
              rules="required"
            >
              <b-form-group>
                <label>
                  Type of packages <span class="text-danger">*</span>
                  <small class="text-muted">1806003000</small>
                </label>
                <b-form-input
                  v-model="pkg.type_of_packages"
                  :disabled="disabled"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            cols="12"
            md="4"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Number of packages"
            >
              <b-form-group>
                <label>
                  Number of packages
                  <small class="text-muted">1806004000</small>
                  <feather-icon
                    v-b-tooltip.hover.top="'Total number of packages of this type'"
                    icon="InfoIcon"
                    size="14"
                    class="ml-50 text-muted"
                  />
                </label>
                <b-form-input
                  v-model="pkg.number_of_packages"
                  type="number"
                  step="1"
                  :disabled="disabled"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            cols="12"
            md="3"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Shipping marks"
            >
              <b-form-group>
                <label>
                  Shipping marks
                  <small class="text-muted">1806054000</small>
                  <feather-icon
                    v-b-tooltip.hover.top="'Marks and numbers on the packages'"
                    icon="InfoIcon"
                    size="14"
                    class="ml-50 text-muted"
                  />
                </label>
                <b-form-textarea
                  v-model="pkg.shipping_marks"
                  rows="4"
                  :disabled="disabled"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            cols="12"
            md="1"
            class="text-right"
          >
            <b-button
              v-if="!disabled"
              variant="link"
              size="sm"
              class="text-danger mt-2"
              @click="removePackage(pkgIndex)"
            >
              <feather-icon icon="TrashIcon" />
              Delete
            </b-button>
          </b-col>
        </b-row>
      </div>

      <b-row>
        <b-col class="text-right">
          <b-button
            v-if="!disabled"
            variant="info"
            size="sm"
            @click="addPackage"
          >
            <feather-icon icon="PlusIcon" />
            New package
          </b-button>
        </b-col>
      </b-row>
    </app-collapse-item>
  </app-collapse>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BButton,
  VBTooltip,
} from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import SectionStatusIcon from '@/views/shipments/declarations/modals/components/h1/SectionStatusIcon.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    ValidationProvider,
    AppCollapse,
    AppCollapseItem,
    SectionStatusIcon,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasPackagingData() {
      if (!this.item || !this.item.goods_data || !this.item.packaging || !Array.isArray(this.item.packaging)) {
        return false
      }
      return this.item.packaging.some(pkg => pkg.type_of_packages || pkg.number_of_packages || pkg.shipping_marks)
    },
  },
  methods: {
    addPackage() {
      if (!this.item.packaging) {
        this.$set(this.item.goods_data, 'packaging', [])
      }
      this.item.packaging.push({
        type_of_packages: '',
        number_of_packages: '',
        shipping_marks: '',
      })
    },
    removePackage(pkgIndex) {
      this.$bvModal.msgBoxConfirm('Are you sure you want to delete this package entry?', {
        title: 'Please Confirm',
        size: 'sm',
        okVariant: 'danger',
        okTitle: 'Yes',
        cancelTitle: 'No',
        centered: true,
      }).then(value => {
        if (value) {
          this.item.packaging.splice(pkgIndex, 1)
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import '@core/scss/base/core/mixins/declarations-mixins';

.collapsible-section-bg {
  @include collapsible-section-bg;
}
</style>
